<template>
  <main>
    <section id="parallax" class="section--full section--banner" @mousemove="parallax">
      <video autoplay muted loop playsinline class="section__video">
        <source src="@/assets/video/contentcreator.mp4" type="video/mp4">
      </video>
    </section>
    <section class="container container--short">
      <div class="container--white">
        <h2 class="heading-detail">Content Creator Performances by MNC Stars</h2>
        <div class="details">
          <p class="description">
             Perayaan ulangtahun MNC Group di bulan November yang ke 32, SMN & StarHits berkolaborasi membuat konten digital yang menarik dengan para content creator tanah air. Saksikan konten-konten menarik dan unik yang dipersembahkan spesial untuk HUT 32 MNC Group.
          </p>
        </div>

        <div class="details">
          <img class="md-image" src="@/assets/images/HUT-MNC_REVISI-2.jpg" alt="">
        </div>

        <div class="details">
          <div class="font-title">Timeline Posting</div>
          <br>
          <ul class="mg-left-35">
            <li class="description list-block">H-7 - 30 October 2021 : Starhits Youtube Channel ( Lord Adi) - Klik di <a class="link" target="_blank" href="https://www.youtube.com/c/StarHitsID">StarHitsID</a></li>
            <li class="description list-block">H-6 - 31 October 2021 : Mahalini Youtube Channel - Klik di <a class="link" target="_blank" href="https://www.youtube.com/c/MahaliniRaharjaOfficial">MahaliniRaharjaOfficial</a></li>
            <li class="description list-block">H-5 - 1 November 2021 : Starplay Youtube Channel - Klik di <a class="link" target="_blank" href="https://www.youtube.com/channel/UC3h5oIIpvhx3fYBH2ISPXNg">Starplay</a></li>
            <li class="description list-block">H-4 - 2 November 2021 : Samuel Youtube channel - Klik di <a class="link" target="_blank" href="https://www.youtube.com/c/SamuelCiptaOfficial">SamuelCiptaOfficial</a></li>
            <li class="description list-block">H-3 - 3 November 2021 : Novia Bachmid Youtube Channel - Klik di <a class="link" target="_blank" href="https://www.youtube.com/c/NoviaBachmid1901">NoviaBachmid</a></li>
            <li class="description list-block">H-2 - 4 November 2021 : Anwar Youtube Channel - Klik di <a class="link" target="_blank" href="https://www.youtube.com/c/AnwarBABChannelOfficial">AnwarBABChannelOfficial</a></li>
            <li class="description list-block">H-1 - 5 November 2021 : Starhits Youtube Channel ( Mark & Melisa) -  Klik di <a class="link" target="_blank" href="https://www.youtube.com/c/StarHitsID">StarHitsID</a></li>
            <li class="description list-block">D-DAY - 6 November  2021: Starhits Channel (Compilation Video) - Klik di <a class="link" target="_blank" href="https://www.youtube.com/c/StarHitsID">StarHitsID</a></li>
          </ul>
        </div>

        <div class="details">
          <div class="font-title">Content Creators:</div>
          <br>
          <ul class="mg-left-35">
            <li class="description list-block">Lord Adi		: 32 Petuah Bijak Lord Adi</li>
            <li class="description list-block">Mahalini		: Starter pack untuk nonton Hut MNC</li>
            <li class="description list-block">Novia Bachmid		: 32 Fun Fact about birthday</li>
            <li class="description list-block">Samuel: Cara bikin birthday surprise & React video failed surprice </li>
            <li class="description list-block">Starplay	: air console, game multiplayer bikin pesta ulangtahun makin pecah</li>
            <li class="description list-block">Anwar BAB	: Masakin menu tumpengan special untum HUT MNC</li>
            <li class="description list-block">Melissa & Mark		: Playlist buat ulang tahun MNC</li>
            <li class="description list-block">Starhits IP	: Compilation Birthday Video</li>
          </ul>
          <br>
           <p class="description">
            Untuk informasi lebih lengkapnya, jangan lupa untuk mengunjungi Official Instagram StarHitsId di <a class="link" target="_blank" href="https://instagram.com/starhitsid">@starhitsid</a>,dan official Youtube StarHitsId di <a class="link" target="_blank" href="https://youtube.com/StarHitsID">StarHitsId</a>
          </p>
        </div>

        <!-- <div class="grid grid--three details">
          <div>
            <img src="https://images.unsplash.com/photo-1579227114347-15d08fc37cae?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1170&q=80" alt="">
          </div>
          <div>
            <img src="https://images.unsplash.com/photo-1553729459-efe14ef6055d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1170&q=80" alt="">
          </div>
          <div>
            <img src="https://images.unsplash.com/photo-1518183214770-9cffbec72538?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80" alt="">
          </div>
        </div> -->
      </div>
    </section>
  </main>
</template>

<script>
import parallax from '@/commons/parallax.js'

export default {
  name: 'DetailContent',
  methods: {
    parallax(e) {
      const elem = document.querySelector("#parallax > video")

      elem.style.top = parallax.parallaxAnimation(e).vidY;
      elem.style.left = parallax.parallaxAnimation(e).vidX;
    
    }
  }
}
</script>